<script setup lang="ts">
import EmptyStateIconUrl from '@Shared/components/visuals/visualAssets/EmptyState_Icon.svg?url';

defineProps<{
  hasNoData?: boolean;
  title?: string;
}>();
</script>
<template>
  <div class="relative h-full flex flex-col rounded-[8px]">
    <!-- Text overlay -->
    <div
      v-if="hasNoData"
      class="absolute top-50% translate-y-[-50%] w-full text-center text-[#828282] xl:text-3 font-family[Roboto] xl:line-height-1rem xs:text-4 xs:line-height-1.5rem"
    >
      <img :src="EmptyStateIconUrl" alt="" />
      <div class="xl:max-w-[200px] xs:max-w-[240px] m-auto">
        <span>
          Nothing to see here. You can try changing the
          <strong>filter</strong> to see some data.
        </span>
      </div>
    </div>

    <div v-if="title" class="xl:text-4 font-600 xs:text-5 mb-4 sm:ml-6 font-family[Roboto] color-[#4F4F4F]">
      {{ title }}
    </div>
    <div v-else class="loading-gradient w-33% h-[10px] mb-[1.5rem] rounded-full ml-6"></div>

    <div class="ml-10">
      <!-- Program Title -->
      <div class="w-full h-[10px]">
        <div class="inline-block loading-gradient h-100% w-33% rounded-2"></div>
      </div>

      <div class="flex w-full mt-4 mb-[1.5rem]">
        <!-- Program breakdown bar -->
        <div class="flex w-60% gap-[5px] mr-8">
          <div class="loading-gradient w-33% h-[1.5rem] rounded-l-full"></div>
          <div class="loading-gradient w-33% h-[1.5rem]"></div>
          <div class="loading-gradient w-33% h-[1.5rem] rounded-r-full"></div>
        </div>

        <!-- Program breakdown other stuff -->
        <div class="loading-gradient rounded-full h-[10px] w-[4rem] self-end mr-4"></div>
        <div class="loading-gradient rounded-full h-[10px] w-[4rem] self-end"></div>

        <!-- spacer -->
        <div></div>
      </div>
    </div>

    <div class="mb-[1.35rem] h-[2px] loading-gradient"></div>

    <div class="ml-10">
      <!-- Program Title -->
      <div class="w-full h-[10px]">
        <div class="inline-block loading-gradient h-100% w-33% rounded-2"></div>
      </div>

      <div class="flex w-full mt-4 mb-[1.5rem]">
        <!-- Program breakdown bar -->
        <div class="flex w-60% gap-[5px] mr-8">
          <div class="loading-gradient w-33% h-[1.5rem] rounded-l-full"></div>
          <div class="loading-gradient w-33% h-[1.5rem]"></div>
          <div class="loading-gradient w-33% h-[1.5rem] rounded-r-full"></div>
        </div>

        <!-- Program breakdown other stuff -->
        <div class="loading-gradient rounded-full h-[10px] w-[4rem] self-end mr-4"></div>
        <div class="loading-gradient rounded-full h-[10px] w-[4rem] self-end"></div>

        <!-- spacer -->
        <div></div>
      </div>
    </div>
  </div>
</template>
<style scoped></style>
